import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ShieldAlert } from "lucide-react";

export default function FraudAdmin() {
  const [flags, setFlags] = useState([]);
  useEffect(() => { api.get("/admin/fraud").then((r) => setFlags(r.data)); }, []);

  return (
    <div data-testid="adm-fraud-page">
      <PageHeader eyebrow="Compliance" title="Fraud & compliance dashboard" subtitle="Detected risks, manual flags, and watch lists." />

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {[
          { label: "Active flags", value: flags.length },
          { label: "Watch list", value: flags.filter((f) => f.status === "watch").length },
          { label: "Suspended", value: flags.filter((f) => f.status === "suspended").length },
          { label: "Cleared", value: flags.filter((f) => f.status === "clear").length },
        ].map((s, i) => (
          <Card key={i} className="border-gray-200 shadow-none rounded-2xl">
            <CardContent className="p-5">
              <div className="text-xs uppercase tracking-[0.18em] text-gray-500 font-semibold">{s.label}</div>
              <div className="font-display font-bold text-2xl mt-1">{s.value}</div>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card className="border-gray-200 shadow-none rounded-2xl">
        <CardContent className="p-0">
          <table className="w-full text-sm">
            <thead className="border-b border-gray-200 bg-gray-50">
              <tr className="text-left">
                <th className="px-5 py-3 font-semibold">User ID</th>
                <th className="px-5 py-3 font-semibold">Status</th>
                <th className="px-5 py-3 font-semibold">Created</th>
              </tr>
            </thead>
            <tbody>
              {flags.map((f) => (
                <tr key={f.id} className="border-b border-gray-100">
                  <td className="px-5 py-3 font-mono text-xs">{f.user_id}</td>
                  <td className="px-5 py-3"><Badge variant="outline" className="capitalize">{f.status}</Badge></td>
                  <td className="px-5 py-3 text-gray-500">{new Date(f.created_at).toLocaleDateString()}</td>
                </tr>
              ))}
              {flags.length === 0 && (
                <tr><td colSpan="3" className="px-5 py-12 text-center">
                  <ShieldAlert className="w-8 h-8 text-gray-400 mx-auto mb-2" />
                  <div className="text-gray-500">No active fraud flags. All clear.</div>
                </td></tr>
              )}
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>
  );
}
